import React, { useContext } from "react";
import { PhotoManagerContext } from "./index";
import EventViewBreadcrumb from "./EventViewBreadcrumb";
import AlbumListBreadcrumb from "./AlbumListBreadcrumb";
import PhotoGridBreadcrumb from "../components/PhotoGridBreadcrumb";
import { EventType } from "./types";
import FolderViewBreadcrumb from "./FolderViewBreadcrumb";

interface BreadcrumbsProps {
  handleAlbumClick?: (selectedEvent: EventType, e: React.MouseEvent) => void;
  viewType: "EventView" | "AlbumList" | "NoAlbum" | "PhotoGrid" | "Folder";
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  handleAlbumClick,
  viewType
}) => {
  const context = useContext(PhotoManagerContext);

  if (!context) {
    return (
      <div className="loading-spinner">
        <span className="fa fa-spinner fa-spin"></span>
      </div>
    );
  }

  if (viewType === "EventView") {
    return <EventViewBreadcrumb />;
  }
  if (viewType === "Folder") {
    return <FolderViewBreadcrumb />;
  }

  if (viewType === "AlbumList" || viewType === "NoAlbum") {
    return <AlbumListBreadcrumb />;
  }

  return <PhotoGridBreadcrumb handleAlbumClick={handleAlbumClick} />;
};

export default Breadcrumbs;
